var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.isEbook===1)?_c('BookDetail',{attrs:{"productDetail":_vm.productDetail}}):_vm._e(),(_vm.isEbook===0)?_c('ProductDetail'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }